import { render } from "./binderCard.vue?vue&type=template&id=2a39409f&scoped=true"
import script from "./binderCard.vue?vue&type=script&lang=js"
export * from "./binderCard.vue?vue&type=script&lang=js"

import "./binderCard.vue?vue&type=style&index=0&id=2a39409f&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a39409f"]])

export default __exports__